import Google_review from "../assets/Google_Review_For_Website.png";
import QR from "../assets/images/QR.png";
import KumarUjjvalReview from "../assets/vernacular_page/KumarUjjvalReview.png";
import SagarKumarReview from "../assets/vernacular_page/SagarKumarReview.png";
import DhirajKumarReview from "../assets/vernacular_page/DhirajKumarReview.png";
import pat_bg from "../assets/images/pat_bg.png";

const L4 = () => {
  return (
    <section className="relative w-full flex flex-col items-center">
      {/* Background */}
      <div
        className="absolute top-0 left-0 w-full rounded-b-3xl overflow-hidden"
        style={{
          backgroundImage: `url(${pat_bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: -10,
          height: "calc(100% - 120px)",
        }}
      />

      {/* Main content */}
      <div className="w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-10 pt-16 sm:pt-24 lg:pt-32 relative z-10">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row gap-8 justify-between items-center">
          {/* Left: QR + Text */}
          <div className="flex-1 flex flex-col items-center lg:items-start text-center lg:text-left space-y-4">
            <img
              src={QR}
              alt="QR Code"
              className="w-28 h-28 sm:w-36 sm:h-36"
            />
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight">
              Pathyacharya App
            </h1>
            <h2 className="text-base sm:text-lg lg:text-xl font-semibold">
              The App to prepare for your Board Exams
            </h2>
            <p className="text-sm sm:text-base lg:text-lg mt-2 font-bold text-[#FF6F00]">
              अब हर घर में स्कूल
            </p>
            <p className="text-sm sm:text-base md:text-lg lg:text-lg xl:text-xl leading-relaxed font-semibold text-gray-700">
              Schooglink provides complete curriculum covering all subjects for
              grades Kindergarten to XII (K-12) across multiple State Boards,
              CBSE & NCERT, in multiple vernacular languages, through its smart
              App - Pathyacharya.
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mt-4 justify-center sm:justify-start items-center">
              <img
                src={Google_review}
                alt="Google Review"
                className="h-10 sm:h-12"
              />
              <a
                href="https://play.google.com/store/apps/details?id=com.schooglink.curriculum.pathcharya"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  className="h-10 sm:h-12"
                />
              </a>
            </div>
          </div>

          {/* Right: Phone Image */}
          <div className="flex-1 flex justify-center lg:justify-end">
            <img
              src="https://images.schooglink.com/image/website/phone_for_web.png"
              alt="App Phone"
              className="w-full max-w-sm sm:max-w-md lg:max-w-lg h-auto object-contain"
            />
          </div>
        </div>

        {/* Reviews Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12 sm:mt-16 place-items-center">
          <img
            src={KumarUjjvalReview}
            alt="Kumar Ujjval Review"
            className="w-full max-w-xs h-auto object-contain"
          />
          <img
            src={SagarKumarReview}
            alt="Sagar Kumar Review"
            className="w-full max-w-xs h-auto object-contain"
          />
          <img
            src={DhirajKumarReview}
            alt="Dhiraj Kumar Review"
            className="w-full max-w-xs h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default L4;
